"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var I18n = require("i18n-js");
var React = require("react");
var cms_page_cards_1 = require("@reverbdotcom/commons/dist/cms/components/cms_page_cards");
var core_link_1 = require("@reverbdotcom/commons/dist/components/core_link");
var CTA_URL = '/page/handpicked-collections';
function renderAction() {
    return (React.createElement(core_link_1.default, { to: CTA_URL }, I18n.t('discovery.homepageCuratedSetRow.cta')));
}
function getPageFields() {
    return [
        {
            slug: 'deals-and-steals',
        },
        {
            slug: 'price-drops',
        },
        {
            slug: 'reverb-exclusives-and-makers',
        },
    ];
}
function HomepageCuratedSetRow() {
    return (React.createElement(cms_page_cards_1.default, { title: I18n.t('discovery.homepageCuratedSetRow.title'), action: renderAction(), pageFields: getPageFields() }));
}
exports.default = HomepageCuratedSetRow;
//# sourceMappingURL=homepage_curated_set_row.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/homepage_curated_set_row.js
// module id = mnGn
// module chunks = 20 21